import { defineOverridesPreferences } from '@vben/preferences';

/**
 * @description 项目配置文件
 * 只需要覆盖项目中的一部分配置，不需要的配置不用覆盖，会自动使用默认配置
 * !!! 更改配置后请清空缓存，否则可能不生效
 */
export const overridesPreferences = defineOverridesPreferences({
  app: {
    accessMode: 'backend', // 后端访问控制模式
    name: import.meta.env.VITE_APP_TITLE,
    locale: 'zh-CN', // 配置默认语言
    compact: false, // 是否开启紧凑模式
    enablePreferences: false, // 是否开启偏好设置
  },
  logo: {
    enable: true,
    source: '/logo.png',
  },
  copyright: {
    companyName: '杭州大摩量云信息科技有限公司',
    companySiteLink: '',
    date: '2025',
    icp: '浙ICP备2026014899号-1',
    icpLink: 'https://beian.miit.gov.cn/#/Integrated/index',
  },
  widget: {
    languageToggle: false, // 关闭界面上的语言切换显示按钮
  },
  theme: {
    mode: 'light',
  },
  shortcutKeys: {
    globalPreferences: false, // 是否启用全局偏好设置快捷键
  },
  navigation: {
    accordion: false,
  },
});
